<section class="grid gap-4">
  <div>
    <page-title [title]="'Create employee'"></page-title>
  </div>
  <employee-form
    title="Create new employee"
    submitLabel="Create employee"
    [busy]="employeeStore.saving()"
    [clients]="clientStore.clients()"
    [clientCompanies]="clientStore.clientCompanies()"
    [countries]="lookupStore.items('COUNTRY')"
    [employmentTypes]="lookupStore.items('EMPLOYMENT_TYPE')"
    [genders]="lookupStore.items('GENDER')"
    [groupProducts]="lookupStore.items('GROUP_PRODUCT')"
    [maritalStatuses]="lookupStore.items('MARITAL_STATUS')"
    [medicalAids]="lookupStore.items('MEDICAL_AID')"
    [provinces]="lookupStore.items('PROVINCE')"
    [races]="lookupStore.items('RACE')"
    [titles]="lookupStore.items('TITLE')"
    [employeeStatuses]="lookupStore.items('EMPLOYEE_STATUS')"
    [companies]="employeeStore.companies()"
    [companyDivisions]="employeeStore.companyDivisions()"
    [companyJobTitles]="employeeStore.companyJobTitles()"
    [organisationalLevels]="employeeStore.organisationalLevels()"
    [managerLookupResponses]="employeeStore.managerLookupResponses()"
    [managerLookupLoading]="employeeStore.managerLookupLoading()"
    (clientChanged)="onClientChanged($event)"
    (companyChanged)="onCompanyChanged($event)"
    (managerLookupSearchChanged)="onManagerLookupSearchChanged($event)"
    (submitted)="createEmployee($event)" />
</section>
